<template>
  <div class="huanjing-page">
		<div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner safeproduct_banner">
			<div class="bodyinfo" style="text-align: left;">
				<h2>安全生产</h2>
				<p>监测采集、探头布控、图片分析、报警提醒</p>
				<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
			</div>
		</div>
		<div>
			<div class="safeproduct_body">
				<div class="safeproduct1">
					<span class="span1">APPLICATION</span>
					<span class="span2">安全生产</span>
					<img class="img1" src="../../html/image/safeproduct/4.webp">
					<span class="span3">高危区域视觉分析</span>
				</div>
				<div class="safeproduct2">
					<span class="span1">人工智能算法、报警分析</span>
					<span class="span2">越界检测、工服检测、防护检测</span>
					<img class="img1" src="../../html/image/safeproduct/6.webp">
					<img class="img2" src="../../html/image/safeproduct/1.webp">
				</div>
				<div class="safeproduct3">
					<span class="span2">电子围栏、人员活动、探头布控</span>
					<img class="img1" src="../../html/image/safeproduct/5.webp">
					<img class="img2" src="../../html/image/safeproduct/3.png">

				</div>
			</div>	
		</div>	
		<Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'viewChemicalIndustry',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css2/zkm.css';
  @import '../../html/css2/zkm.market.css';
</style>